// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, getPromotionDetailsProfessional } from "../../Utils/Constants";
import { toast } from "react-toastify";

export const hitPromotionDetailsProfessionalApi = createAsyncThunk(
  "hitPromotionDetailsProfessionalApi",
  async (payload) => {
    try {
      const config = {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          Authorization: `${localStorage.getItem("professionalToken")}`,
        },
        params: payload,
      };
      const url = ApiBaseUrl + getPromotionDetailsProfessional;
      const response = await axios.get(url, config);
      return response.data;
    } catch (error) {
        if(error.status === 401){
          localStorage.removeItem("professionalToken");
          localStorage.removeItem("professionalData");
          localStorage.removeItem("professionalId");
          window.location.href = "/professional/login";
        }
      toast.error(error.response.data.message);
      throw error.response.data;
    }
  }
);

const PromotionDetailsProfessionalSlice = createSlice({
  name: "promotionDetailsProfessionalReducer",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearhitPromotionDetailsProfessionalData: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitPromotionDetailsProfessionalApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitPromotionDetailsProfessionalApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(hitPromotionDetailsProfessionalApi.rejected, (state) => {
        state.isError = false;
      });
  },
});

export const { clearhitPromotionDetailsProfessionalData } = PromotionDetailsProfessionalSlice.actions;
export default PromotionDetailsProfessionalSlice.reducer;
